module.exports = {"410671400":"东杨路","410671401":"渤海路","410671402":"海河路"}


//////////////////
// WEBPACK FOOTER
// ./src/town/410671.json
// module id = 1702
// module chunks = 0